import React, { Component } from "react";
import {
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  UncontrolledTooltip,
  Button
} from "reactstrap";
import LessonCard from "../LessonCard";
import DeleteButton from "../AuthorUIComponents/DeleteButton";

export default class LessonRules extends Component {
  
  deleteRule = () => {
    console.log("rule deleted!!");
  };
  render() {
    const indexes = [0, 1];
    const rulesBodyLeft = (
      <React.Fragment>
        <Form inline>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0 rules-item">
            <Col xs="12" sm="12" md="2" className="rule-number">
              Rule #1
            </Col>
            <Label
              id={`rule_threshold_item-left-${indexes[0]}`}
              for="rule_threshold"
            >
              Entrance Threshold to Fast Forward:{" "}
            </Label>
            <Input
              type="number"
              name="rule_threshold"
              id="rule_threshold"
              value="100"
            />
            %
            <DeleteButton handleDelete={this.deleteRule} index={1} />
            <UncontrolledTooltip
              placement="bottom"
              target={`rule_threshold_item-left-${indexes[0]}`}
              style={{ backgroundColor: "#4C4C4C" }}
            >
              Rules description...
            </UncontrolledTooltip>
          </FormGroup>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0 rules-item">
            <Col xs="12" sm="12" md="2" className="rule-number">
              Rule #2
            </Col>
            <Label
              id={`rule_threshold_item-left-${indexes[1]}`}
              for="rule_threshold"
            >
              Entrance Threshold to Fast Forward:{" "}
            </Label>
            <Input
              type="number"
              name="rule_threshold"
              id="rule_threshold"
              value="100"
            />
            %
            <DeleteButton handleDelete={this.deleteRule} index={2} />
            <UncontrolledTooltip
              placement="bottom"
              target={`rule_threshold_item-left-${indexes[1]}`}
              style={{ backgroundColor: "#4C4C4C" }}
            >
              Rules description...
            </UncontrolledTooltip>
          </FormGroup>
        </Form>
      </React.Fragment>
    );
    const rulesBodyRight = (
      <React.Fragment>
        <div className="filter-input">
          <Input type="text" name="rules_filter" placeholder="Search" />
        </div>
        <Form inline>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0 rules-item">
            <div className="author-lesson-checkbox">
              <Input type="checkbox" />
              <span class="checkmark" />
            </div>
            <Label
              id={`rule_threshold_item-right-${indexes[0]}`}
              for="rule_threshold"
            >
              Entrance Questions:{" "}
            </Label>
            <Input type="number" name="rule_threshold" id="rule_threshold" />
            questions
            <UncontrolledTooltip
              placement="bottom"
              target={`rule_threshold_item-right-${indexes[0]}`}
              style={{ backgroundColor: "#4C4C4C" }}
            >
              Rules description...
            </UncontrolledTooltip>
          </FormGroup>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0 rules-item">
            <div className="author-lesson-checkbox">
              <Input type="checkbox" />
              <span class="checkmark" />
            </div>
            <Label
              id={`rule_threshold_item-right-${indexes[1]}`}
              for="rule_threshold"
            >
              Entrance Threshold to Fast Forward:{" "}
            </Label>
            <Input type="number" name="rule_threshold" id="rule_threshold" />%
            <UncontrolledTooltip
              placement="bottom"
              target={`rule_threshold_item-right-${indexes[1]}`}
              style={{ backgroundColor: "#4C4C4C" }}
            >
              Rules description...
            </UncontrolledTooltip>
          </FormGroup>
        </Form>
      </React.Fragment>
    );
    return (
      <div>
        <React.Fragment>
          <LessonCard
            iconClass="rules-yellow"
            heading="Lesson Rules"
            isCollapsable={true}
            headerButtons={[
              <Button
                className={`add-btn active`}
                onClick={() => this.props.AddRule()}
              >
                + Add Rules
              </Button>
            ]}
            children={rulesBodyLeft}
          />
        </React.Fragment>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorLesson/LessonRules.js